/**
 * @generated SignedSource<<f67f82b196af8b5fa64b5afcbc3fc905>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type mynewsPageQuery$variables = Record<PropertyKey, never>;
export type mynewsPageQuery$data = {
  readonly appConfig: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
};
export type mynewsPageQuery = {
  response: mynewsPageQuery$data;
  variables: mynewsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "filter",
        "value": {
          "entityId": "scmp_pwa_my_news"
        }
      }
    ],
    "concreteType": "AppConfigs",
    "kind": "LinkedField",
    "name": "appConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "json",
        "storageKey": null
      }
    ],
    "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_my_news\"})"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "mynewsPageQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "mynewsPageQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "8b27a4964c94ae8a252a7631c83c9edb",
    "id": null,
    "metadata": {},
    "name": "mynewsPageQuery",
    "operationKind": "query",
    "text": "query mynewsPageQuery {\n  appConfig(filter: {entityId: \"scmp_pwa_my_news\"}) {\n    json\n  }\n}\n"
  }
};
})();

(node as any).hash = "ec4103fe78739a05d541897b8258cb84";

export default node;
